<template>
  <div style="height: inherit">
    <div
      class="body-content-overlay"
      :class="{ show: isShowLeftSidebar }"
      @click="isShowLeftSidebar = false"
    />

    <right-sidebar 
      :is-show-left-sidebar.sync="isShowLeftSidebar"
      :form-data="editData"
      @refetch-data="reLoadDataTable"
    /> 
    <data-table
      :data-table="dataTable"
      :search-ref.sync="searchTerm"
      :is-loaded="dataTableIsLoaded"
      @show-edit="showLeftSlidebar"
      @remove-item="removeItem"
    />
  </div>
</template>

<script>
    /* eslint-disable */
    import LayoutData from "@/layouts/LayoutData";
    import { } from "bootstrap-vue";
    import Ripple from "vue-ripple-directive";

    import DataTable from "./components/DataTable.vue";

    import { ref, computed, watch } from "@vue/composition-api";
    import store from "@/store";
    import { useRouter } from "@core/utils/utils";

    import { useToast } from "vue-toastification/composition";
    import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

    import { } from "@/services/api/HoSoCanBoCongChuc/CanBoCongChucService";

    import RightSidebar from "./components/RightSidebar.vue";

    import useSetup from "./useSetup";

    export default {
        directives: {
            Ripple,
        },
        components: {
            RightSidebar,
            DataTable,
        },
        data() {
            return {
                isWait: false,
            };
        },
        watch: {},
        methods: {},
        created() {
            this.fetchData();
        },
        setup(props, { emit }) {
            const toast = useToast();
            const { route, router } = useRouter();
            const headerData = ref(LayoutData.header.data);
            const appInfo = ref();
            headerData.value.title = "Hình thức chuyển công tác";
            document.title = headerData.value.title + " | " + LayoutData.appInfo.data.appName;

            const {
                getDataList
            } = useSetup();

            const dataTable = ref([]);
            const isShowLeftSidebar = ref(false);
            const dataTableIsLoaded = ref(false);
            const searchTerm = ref({ value: "" });
            const editData = ref({

            });

            const fetchData = () => {
                dataTableIsLoaded.value = true;
                getDataList({},
                    (data) => {
                        dataTableIsLoaded.value = false;
                        dataTable.value = data || dataTable.value;
                        searchTerm.value.value = "";
                    }
                );
            };

            //After update or Add
            const reLoadDataTable = (data, id) => {
                if (data.id) {
                    let index = dataTable.value.findIndex((el) => el.id == data.id);
                    if (index != -1) {
                        for (var name in dataTable.value[index]) {
                            if (data[name]) {
                                dataTable.value[index][name] = data[name];
                            }
                        }
                    }
                } else {
                    data.id = id;
                    dataTable.value.push(data);
                }

                dataTable.value.sort((a, b) => (a.sort < b.sort) ? 1 : -1);
            };

            const removeItem = (item) => {
                var index = dataTable.value.findIndex((el) => el.id == item.id);
                if (index != -1) {
                    dataTable.value.splice(index, 1);
                }
            };

            const showLeftSlidebar = (data, id) => {
                editData.value = JSON.parse(JSON.stringify(data));
                isShowLeftSidebar.value = true;
            };

            return {
                fetchData,

                dataTable,
                dataTableIsLoaded,
                editData,
                searchTerm,

                isShowLeftSidebar,
                showLeftSlidebar,
                reLoadDataTable,
                removeItem
            };
        },
    };
</script>

<style lang="scss" scoped></style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
